import { type TypedDocumentNode, gql } from '@apollo/client';
import classNames from 'classnames';
import type { Ref } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { Game } from 'components/game/Game';

import type { Games_anyGameInterface } from './__generated__/index.graphql';

const Root = styled(Vertical)`
  &.roundedTop {
    & > *:first-child {
      border-top-right-radius: var(--double-unit);
      border-top-left-radius: var(--double-unit);
    }
  }

  & > *:last-child {
    border-bottom-right-radius: var(--double-unit);
    border-bottom-left-radius: var(--double-unit);
  }
`;

type Props = {
  games: Games_anyGameInterface[];
  hideGameWeek?: boolean;
  roundedTop?: boolean;
  ref?: Ref<HTMLDivElement>;
  onClick?: (id: string) => void;
};
export const Games = ({
  games,
  hideGameWeek,
  roundedTop,
  ref,
  onClick,
}: Props) => {
  return (
    <Root ref={ref} className={classNames({ roundedTop })}>
      {games.map(game => (
        <Game
          key={game.id}
          displayDay={!hideGameWeek}
          game={game}
          onClick={() => onClick?.(game.id)}
        />
      ))}
    </Root>
  );
};

Games.fragments = {
  anyGameInterface: gql`
    fragment Games_anyGameInterface on AnyGameInterface {
      id
      ...Game_anyGameInterface
    }
    ${Game.fragments.anyGameInterface}
  ` as TypedDocumentNode<Games_anyGameInterface>,
};
